
export default {
    getPostbackParameters() {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.getParameters';
        return this.makeRequest(path, {});
    },

    savePostback(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.create';
        params = params || {};
        return this.makeRequest(path, params);
    },

    editPostback(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.edit';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchPostbacks(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.search';
        params = params || {};
        params.fields = 'publisher_postback_config.url,publisher_postback_config.method,publisher_postback_config.currency,publisher_postback_config.locale,publisher_postback_config.conversion_statuses,publisher_postback_config.goal_action_ids,publisher_postback_config.parameters,publisher_postback_config.track_parameter,publisher_postback_config.success_string';
        return this.makeRequest(path, params);
    },

    deletePostback(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.delete';
        params = params || {};
        return this.makeRequest(path, params);
    },

    resendPostback(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbackQueue.resend';
        params = params || {};

        return this.makeRequest(path, params);
    },

    addPostback(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbackQueue.add';
        params = params || {};

        return this.makeRequest(path, params);
    },

    searchPostbackQueue(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbackQueue.search';
        params = params || {};
        params.fields = 'publisher_postback_queue.conversion,publisher_postback_queue.conversion_status,publisher_postback_queue.parameters,publisher_postback_queue.send_attempts,publisher_postback_queue.created_at,publisher_postback_config.url,publisher_postback_config.method,publisher_postback_config.currency,publisher_postback_config.locale,publisher_postback_config.conversion_statuses,publisher_postback_config.goal_action_ids,publisher_postback_config.track_parameter,publisher_postback_config.parameters,publisher_postback_config.success_string,conversion.adv_cid,conversion.contract_dynamic_admin_commission,conversion.currency_ratio,conversion.track,currency_ratio.rates,commission.contract,commission.sale_sum,commission.promotion_personal_percent,commission.promotion_per_lead,commission.promotion_per_sale,track.request,track.created_at,track_request.region,track_request.ip,track_request.device';
        return this.makeRequest(path, params);
    }
};